__turbopack_context__.v({
  "className": "montserrat_3cafdf6e-module__O2lhRW__className",
  "variable": "montserrat_3cafdf6e-module__O2lhRW__variable",
});
